import {
  ActionIcon,
  Affix,
  Tooltip,
  useMantineColorScheme,
} from "@mantine/core";
import { IconMoonStars, IconSun } from "@tabler/icons-react";

import { useFooterOffset } from "@/hooks/use-footer-offset";
import { trackEvent } from "@/tracking";

export function ThemeSelector() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const bottom = useFooterOffset(20);

  return (
    <Affix position={{ bottom, left: 80 }}>
      <Tooltip
        label={isDark ? "Switch to light" : "Switch to dark"}
        position="right"
        withArrow
      >
        <ActionIcon
          size={48}
          radius="xl"
          variant="default"
          aria-label="Toggle colour theme"
          onClick={() => {
            trackEvent("Theme Toggle", {
              from: colorScheme,
              to: isDark ? "light" : "dark",
            });
            toggleColorScheme();
          }}
        >
          {isDark ? <IconMoonStars size={22} /> : <IconSun size={22} />}
        </ActionIcon>
      </Tooltip>
    </Affix>
  );
}

export default ThemeSelector;
